import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does mobile app development cost in San Francisco?",
    answer: ` <p>The cost for mobile app development depends on different factors, however, if you wish to get a better insight then, use our app cost calculator, and get an estimation.</p>`,
  },
  {
    question: " How do you confirm the security of my app and user data?",
    answer: `<p>TekRevol utilizes industry-leading practices and ethical standards to safeguard data. Our dedicated team conducts rigorous vulnerability testing to ensure that our applications are fortified with robust security measures.</p>`,
  },
  {
    question: " I have an app idea! Do you help with consultation?",
    answer: `<p>Yes, we provide strategic consultation to businesses looking to validate their app idea and define their product journey through a leading app development company in San Francisco.</p>`,
  },
  {
    question: " How long will it take to develop my mobile app?",
    answer: ` <p>Mobile application development timeline varies depending on the app’s scope, the complexity of features, and budget and timelines.</p>
        <p>On average, the basic version of any app with limited features takes up to three months, while a more complex application with multiple features, UX challenges, and top-tier functionality will consume a considerable number of development hours.</p>
        <p>Our mobile app development in San Francisco team will understand your project considerations and scope and allot development hours for each phase.</p>`,
  },
  {
    question: " What is the team strength that will work on my project?",
    answer: `<p>For basic development, mobile app development companies in San Francisco align project managers, frontend and backend developers, UI/UX designers, QA engineers, and product owners.</p>`,
  },
  {
    question: "Should I get an Android or iOS application?",
    answer: `<p>Your target audience and business goals will determine which platform you should choose before hiring a mobile app developer in San Francisco.</p>
        <p>If your goal focuses on branding and the optimum number of downloads, then an Android application is the choice.</p>
        <p>However, if you want to register in-app purchases through a sound monetization model, go for an iOS application.</p>`,
  },
  {
    question: " Why should we choose TekRevol for our app development project?",
    answer: ` <p>Our app developers San Francisco team has ample experience and onboarded talent to produce digital products for various platforms and industries. We have experience creating mobile apps from scratch and have worked alongside existing development teams to modify existing systems, including technically complex features, and bring together systems, processes, and tools with seamless integration.</p>`,
  },
  {
    question: " What platforms do you craft apps for?",
    answer: ` <p>We excel in creating applications for both Android and iOS platforms. Our developers are skilled in producing native and cross-platform apps, ensuring that your app reaches the widest possible audience.</p>`,
  },
  {
    question: "  What do mobile application development services include?",
    answer: ` <p>If you’re looking to hire an app developer, you’ll also consider what services mobile app development agencies offer. TekRevol offers full-cycle app development services for iOS and Android, cross-platform, game app development, UIUX design, strategy consultation, web and backend coding, testing, app store launch, and post-launch support and maintenance.</p>`,
  },
  {
    question: "Where are you located in San Francisco?",
    answer: ` <p>We are located at “45 Tehama St, San Francisco, CA 94105”.</p>`,
  },
  {
    question:
      "How do I find the right app developers near me in San Francisco?",
    answer: ` <p>You can simply search mobile app developers near me on Google and you’ll have multiple options against your search. After that, you can review the website of the top app development companies and explore their previous works. Once you've found the right app developers in San Francisco, you can get in touch with them and discuss your project's requirements. </p>`,
  },
  {
    question:
      "How do I find expert mobile app developers in San Francisco near me?",
    answer: ` <p>You can search for local developers on Google to find expert mobile app developers in San Francisco near me. Review their websites to explore their portfolios and services. Contact them directly using their provided information to discuss your project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
